import { render } from "./InstrumentSource.vue?vue&type=template&id=60b72e11&scoped=true"
import script from "./InstrumentSource.vue?vue&type=script&lang=js"
export * from "./InstrumentSource.vue?vue&type=script&lang=js"

import "./InstrumentSource.vue?vue&type=style&index=0&id=60b72e11&scoped=true&lang=css"

import exportComponent from "/builds/Xpansiv/evo/DataPipeline/DataPipeline.Evolve.Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b72e11"]])

export default __exports__